import React from "react";

const CompanyAliasesEditor = ({
  companyAliases,
  onAddCompanyAlias,
  onRemoveCompanyAlias,
  onCompanyAliasChange,
}) => (
  <div className="space-y-3 rounded-2xl border border-slate-800/90 bg-slate-950/40 p-4">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div>
        <p className="text-sm font-semibold text-slate-100">Aliases</p>
        <p className="mt-1 text-xs text-slate-400">Keep this list short enough to scan quickly.</p>
      </div>
      <button
        type="button"
        onClick={onAddCompanyAlias}
        className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-slate-500 hover:text-white"
      >
        Add alias
      </button>
    </div>

    <div className="max-h-64 space-y-2 overflow-y-auto pr-1">
      {companyAliases.length ? (
        companyAliases.map((alias, index) => (
          <div
            key={`company-alias-${index}`}
            className="flex items-center gap-2 rounded-xl border border-slate-800 bg-slate-900/60 p-2"
          >
            <div className="min-w-0 flex-1">
              <input
                type="text"
                value={alias}
                onChange={(event) => onCompanyAliasChange(index, event.target.value)}
                aria-label={`Alias ${index + 1}`}
                placeholder={`Alias ${index + 1}`}
                className="min-h-[3rem] w-full rounded-lg border border-slate-700 bg-slate-950/80 px-3 py-2 text-sm text-slate-100 outline-none transition-all focus:border-sky-500/60 focus:ring-2 focus:ring-sky-500/20"
              />
            </div>
            <button
              type="button"
              onClick={() => onRemoveCompanyAlias(index)}
              className="rounded-lg border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-xs font-semibold text-rose-100 transition-colors hover:border-rose-400 hover:text-white"
              aria-label={`Remove alias ${index + 1}`}
            >
              Remove
            </button>
          </div>
        ))
      ) : (
        <div className="rounded-2xl border border-dashed border-slate-700 px-4 py-4 text-sm text-slate-400">
          No aliases yet. Add one to start editing this list.
        </div>
      )}
    </div>
  </div>
);

export default CompanyAliasesEditor;
